<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
    
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <div class="d-flex flex-column flex-column-fluid">

            <!--begin::Toolbar-->
            <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
                <!--begin::Toolbar container-->
                <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                    <!--begin::Page title-->
                    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <!--begin::Title-->
                     <div class="d-flex align-items-center">
                        <h1 class="page-heading mt-0 mb-0"> <svg width="41" height="44" viewBox="0 0 41 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_615_2549)">
                            <path d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z" fill="#265D91"/>
                            <path d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z" fill="#265D91"/>
                            <path d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z" fill="#265D91"/>
                            <path d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_615_2549" x="0.756836" y="0.158081" width="39.501" height="43.6498" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_615_2549"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_615_2549" result="shape"/>
                            </filter>
                            </defs>
                            </svg>

                            Candidature
                        </h1>
                            <!--begin::Menu-->
                     </div>
                        <!--end::Title-->
                        <!--begin::Breadcrumb-->
                        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">
                                <a routerLink="/accueil" class="text-muted ">Accueil</a>
                              </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item">
                                <span class="bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted cursor-pointer" routerLink="/esn-offres-emploi/list-offres" >Offres du marché</li>
                            <li class="breadcrumb-item">
                                <span class="bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li class="breadcrumb-item text-muted"> Candidature</li>
                            <!--end::Item-->
                        </ul>
                        <!--end::Breadcrumb-->
                    </div>
                    <!--end::Page title-->
                    <!--begin::Actions-->

                    <!--end::Actions-->
                </div>
                <!--end::Toolbar container-->
            </div>
            <!--end::Toolbar-->
            <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card">
                        <!--begin::Card header-->
                        <form [formGroup]="searchForm">
                            <div class="card-body">
                                <div class="title mb-10">
                                    <h4>Recherche</h4>
                                </div>
                                <div class="row mb-5">
                                    <div class="col-lg-6">
                                        <div class="input-group search-libre">
                                            <span class="input-group-text">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                                    fill="none">
                                                    <path
                                                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                                        fill="#7E7C7C" />
                                                </svg>
                                            </span>
                                
                                            <input type="text" data-kt-customer-table-filter="search" 
                                                class="form-control ps-5" placeholder="Rechercher" formControlName="search"  (keyup.enter)="searchoffrebesoinesn(1); startSearching = true"/>
                                                <div class="tooltip-container tooltip-info">
                                                    <div class="tooltip-trigger"><i class="fa-solid fa-circle-info" style="font-size: 20px;"></i></div>
                                                    <div class="tooltip-content">
                                                      <div class="content">
                                                        <h4>Opérateur AND :</h4>
                                                        <p>Utilisez l'opérateur AND pour spécifier que les résultats doivent inclure plusieurs termes.
                                                        </p>
                                                        <p>Exemple : software AND engineer renverra des profils qui mentionnent à la fois "software" et "engineer".
                                                        </p>
                                                        <h4>Opérateur OR :</h4>
                                                        <p>Utilisez l'opérateur OR pour spécifier que les résultats peuvent inclure l'un des termes.
                                                        </p>
                                                        <p>Exemple : sales OR marketing renverra des profils qui mentionnent soit "sales" soit "marketing".
                                                        </p>
                                                        <h4>Opérateur NOT :</h4>
                                                        <p>Utilisez l'opérateur NOT pour exclure des termes spécifiques des résultats.
                                                        </p>
                                                        <p>Exemple : developer NOT manager renverra des profils qui mentionnent "developer" mais pas "manager".
                                                        </p>
                                                        <h4>Guillemets pour une expression exacte :</h4>
                                                        <p>Utilisez des guillemets pour rechercher une expression exacte.
                                                        </p>
                                                        <p>Exemple : "product manager" renverra des profils qui mentionnent exactement "product manager".
                                                        </p>
                                                        <h4>Parenthèses pour grouper des opérations :</h4>
                                                        <p>Utilisez des parenthèses pour définir l'ordre d'évaluation des opérations.
                                                        </p>
                                                        <p>Exemple : (sales OR marketing) AND manager renverra des profils qui mentionnent "sales" ou "marketing" et "manager".
                                                        </p>
                                                        <h4>Recherche standard :</h4>
                                                        <p>Si aucun opérateur n'est spécifié dans la recherche, le texte sera interprété comme s'il était entre guillemets.
                                                        </p>
                                                        <p>Exemple : La recherche product manager sera traitée comme "product manager", suivant la règle 4.
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <!-- <div class="text-danger mt-2"
                                                  *ngIf="searchForm.get('search')?.hasError('pattern') && searchForm.get('search')?.touched && isSimpleWord(searchForm.get('search')?.value)">
                                                  Le modèle de recherche est invalide.
                                                </div> -->
                                       
                                            </div>
                                     </div>
                                  </div>
                                <div class="tools">
                                    <div class="form-grid">
                                        <div class="form-item">
                                            <input type="text" formControlName="ID_jobOffer" id="Poste"
                                                class="form-control form-control-solid" placeholder="ID">
    
                                        </div>
                                        <div class="form-item">
                                            <input type="text" formControlName="name" id="Poste"
                                                class="form-control form-control-solid" placeholder="Poste">
    
                                        </div>
                                        <div class="form-item">
                                            <input type="text" formControlName="esn_name" id="Poste"
                                                class="form-control form-control-solid" placeholder="Nom Entreprise">
    
                                        </div>
                                        <div class="form-item">
                                            <div class="combined-input">
                                             
                                                <input type="number" formControlName="years_of_experience"
                                                    oninput="validity.valid||(value='0');" min="0" class="form-control"
                                                    placeholder="Année d’éxperience" aria-label="Amount (to the nearest dollar)"
                                                    class="nb1" />
                                                <input type="number" formControlName="experience_range"
                                                    oninput="validity.valid||(value='0');" min="0" class="nb2" value=""
                                                    placeholder="marge_année d’exp" id="marge_année d’exp">
    
                                                <div class="plusetmois">
                                                    <i class="fa-solid fa-plus-minus"></i>
                                                </div>
    
                                            </div>
                                        </div>
                                        <ng-container >
                                            <div class="row" *ngIf="seeMore"> 
                                                <div class="col-lg-3">
                                                    <ng-select [items]="contrat" [bindValue]="'id'" [multiple]="true" [notFoundText]="'Aucun élément trouvé'"
                                                        [bindLabel]="'name'" id="contrat" formControlName="contract_type"
                                                         placeholder="Type de contrat">
                                                    </ng-select>
                                                </div>
                                                <div class="col-lg-3">
                                                    <div class="combined-input">
                                                        <input type="number" formControlName="desired_salary"
                                                            oninput="validity.valid||(value='0');" min="0" class="nb1"
                                                            placeholder="Salaire" id="Salaire">
                                                        <div class="euro">
                                                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                                    fill="#4B4B4B" />
                                                            </svg>
                                                        </div>
                                                        <input type="number" formControlName="desired_salary_range" (input)="onSalaryRangeInput($event)"
                                                            oninput="validity.valid||(value='0');" min="0" class="nb2" value=""
                                                            id="marge_tjm">
                                                        <div class="icon">
                                                            <svg width="20" height="15" viewBox="0 0 19 11" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                                                                    fill="#4B4B4B" />
                                                                <path
                                                                    d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                                                                    fill="#4B4B4B" />
                                                            </svg>
                                                        </div>
                                                        <div class="plusetmois">
                                                            <i class="fa-solid fa-plus-minus"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3">
                                                    <div class="combined-input">
                                                        <input type="number" formControlName="tjm"
                                                            oninput="validity.valid||(value='0');" min="0" class="nb1"
                                                            placeholder="TJM" id="tjm">
                                                        <div class="euro">
                                                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                                    fill="#4B4B4B" />
                                                            </svg>
                                                        </div>
                                                        <input type="number" formControlName="tjm_range"
                                                            oninput="validity.valid||(value='0');" min="0" class="nb2" value=""
                                                            id="marge_tjm">
                                                        <div class="icon">
                                                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                                    fill="#4B4B4B" />
                                                            </svg>
                                                        </div>
                                                        <div class="plusetmois">
                                                            <i class="fa-solid fa-plus-minus"></i>
                                                        </div>
                                                    </div>
            
                                                </div>
                                                <div class="col-lg-3">
                                                    <ng-select [items]="poste" [bindValue]="'id'" [multiple]="true" [notFoundText]="'Aucun élément trouvé'"
                                                        [bindLabel]="'name'" id="Poste" 
                                                        formControlName="post_type" placeholder="Type de poste">
                                                    </ng-select>
                                                </div>
                                                <div class="col-lg-3">
                                                    <ng-select [items]="skillsList"  [notFoundText]="'Aucun élément trouvé'"
                                                        bindLabel="name_FR" formControlName="skillsAnd" bindValue="name_FR"
                                                        [multiple]="true" placeholder="Compétences (et)" autoComplete>
                                                    </ng-select>
                                                </div>
                                                <div class="col-lg-3">
                                                    <ng-select [items]="skillsList"   [notFoundText]="'Aucun élément trouvé'"
                                                        bindLabel="name_FR" formControlName="skillsOr" bindValue="name_FR"
                                                        [multiple]="true" [placeholder]="'Compétences (ou)'" autoComplete>
                                                    </ng-select>
                                                </div>
                                                <div class="col-lg-3">
                                                    <ng-select [items]="disponibilite" [multiple]="true"  [notFoundText]="'Aucun élément trouvé'"
                                                         formControlName="availability"
                                                        bindLabel="name" bindValue="id" [placeholder]="'Disponibilité'"
                                                        autoComplete>
                                                    </ng-select>
                                                </div>
                                                <div class="col-lg-3" *ngIf="connectedUser!='esn-non-abonnee'">
                                                    <ng-select (change)="onCountryChange($event);" [notFoundText]="'Aucun élément trouvé'"
                                                        [items]="paysList" bindLabel="name" formControlName="country" [multiple]="true"
                                                        bindValue="name" [placeholder]="'Pays'" autoComplete>
                                                    </ng-select>
                                                </div>
                                                <div class="col-lg-3">
                                                    <ng-select  [items]="stateList" bindLabel="name" (change)="onMobilityChange('add')"
                                                        formControlName="city" [multiple]="true" bindValue="name" 
                                                        [placeholder]="'Ville'" autoComplete [notFoundText]="'Aucun élément trouvé'">
                                                    </ng-select>
                                                </div>
                                                <div class="col-lg-3">
                                                    <div class="position-relative d-flex align-items-center calenderDate">
                                                        <!--begin::Datepicker-->
                                                        <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Date de début de publication" inputId="yearpicker" 
                                                        formControlName="start_date" class="form-control"
                                                       ></p-calendar>
                                                        <!--end::Datepicker-->
                                                    </div>
                                                </div>
                                                <div class="col-lg-3">
                                                    <div class="position-relative d-flex align-items-center calenderDate">
                                                        <!--begin::Datepicker-->
                                                        <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Date de fin de publication" inputId="yearpicker" 
                                                        formControlName="end_date" class="form-control"
                                                       ></p-calendar>
                                                        <!--end::Datepicker-->
                                                    </div>
                                                </div>
                                                <div class="col-lg-3">
                                                    <ng-select  [items]="profile" bindLabel="name"  [notFoundText]="'Aucun élément trouvé'"
                                                        formControlName="profile_abroad" bindValue="id" [placeholder]="'Profil à l\'étranger'"
                                                        autoComplete>
                                                    </ng-select>
                                                </div>
                                                <div class="col-lg-3"> 
                                                    <ng-select  [items]="passeport" bindLabel="name"  [notFoundText]="'Aucun élément trouvé'"
                                                        formControlName="passeport_talent" bindValue="id" [placeholder]="'Passeport_talent'"
                                                        autoComplete>
                                                    </ng-select>
                                                </div>
        
                                                <div class="col-lg-3">
                                                    <ng-select [items]="state" bindLabel="name" [notFoundText]="'Aucun élément trouvé'"
                                                        formControlName="state" bindValue="id" [placeholder]="'Statut'"
                                                        autoComplete>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-lg-3"></div>
                                        <div class="col-lg-3"></div>
                                        <div class="col-lg-3"></div>
                                        <div class="col-lg-3">
                                            <div class="see-more mb-5">
                                                <a class="" (click)="seeMore=!seeMore">Voir {{!seeMore?'plus':'moins'}} de
                                                    critères de recherche</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3 search-btn d-flex justify-content-end">
                                        <div class="align-items-center recherche">
                                            <button type="button" class="me-5" (click)="searchoffrebesoinesn(1); startSearching = true">
                                                <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                                        fill="white" />
                                                </svg>
                                                Rechercher</button>
                                        </div>
                                        <div class="resett-btn">
                                            <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top" title="Réinitialiser">
                                             <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
                                             </div>
                                          </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
                <!--end::Content container-->
            </div>
            <!--begin::Content-->

            <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card pb-10 pt-10 content-table">

                        <!--begin::Card header-->
                        <div class="d-flex flex-wrap my-1 header-grid align-items-center mb-5">
							<div class="section_title">
								<h1 class="section-heading">Liste des candidatures</h1>
							</div>
							<!--begin::Tab nav-->
							<ul class="nav nav-pills me-5">
								<li class="nav-item m-0">
									<a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3"
										data-bs-toggle="tab" href="#kt_project_targets_card_pane">
										<i class="ki-duotone ki-element-plus fs-1">
											<span class="path1"></span>
											<span class="path2"></span>
											<span class="path3"></span>
											<span class="path4"></span>
											<span class="path5"></span>
										</i>
									</a>
								</li>
								<li class="nav-item m-0">
									<a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
										data-bs-toggle="tab" href="#kt_project_targets_table_pane">
										<i class="ki-duotone ki-row-horizontal fs-2">
											<span class="path1"></span>
											<span class="path2"></span>
										</i>
									</a>
								</li>
							</ul>
							<!--end::Tab nav-->
						</div>
                        <!--end::Card header-->
                        <!--begin::Card body-->
                        <div class="card-body pt-0">
                        <div class="tab-content for-web">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                                <!--begin::Row-->
                                <div class="row g-6 g-xl-9 justify-content-center">
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4" *ngFor="let offre of listcandidature">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="type-esn">
                                                <span *ngIf="offre?.e_s_n?.type=='2'"> Esn</span>
                                                <span *ngIf="offre?.e_s_n?.type=='3'"> Client Final</span>
                                                <span *ngIf="offre?.e_s_n?.type=='4'"> Cabinet de Recrutement</span>
                                                <span *ngIf="!offre.e_s_n?.type">---</span>
                                               </div>
                                            <div class="tools">

                                                <div class="dropdown">
                                                    <button
                                                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                        type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                fill="#265D91" />
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                fill="#265D91" />
                                                        </svg>
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <!-- <a class="dropdown-item dropdown" >Voir offre</a> -->
                                                        <a class="dropdown-item dropdown"  routerLink="/esn-offres-emploi/details-offer-candidature/{{offre.company_apply_id}}">Voir Détail</a>
                                                        <!-- <a class="dropdown-item dropdown" >Modifier</a> -->
    
                                                        <a class="dropdown-item dropdown"  (click)="retirercandidature(offre)">Retirer La candidature</a>
                                                      
                                                        <a   [routerLink]="['/dossier-candidature',offre.id,offre.User_id,3,offre.company_apply_id]"
                                                        class="dropdown-item cursor-pointer" >voir dossier de candidature </a>

                                                    </div>
                                                </div>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <!-- <img src="assets/media//avatars/300-2.jpg" alt="image" /> -->
                                                    <img class="circular-image" *ngIf="offre.e_s_n.logo &&  offre.e_s_n.logo!=='undefined'" src="{{url+'/Company/file/gallery_company/'+ offre.e_s_n.logo}}" alt="logo" width="50px" height="50px">
                                                    <!-- <img *ngIf="offre.e_s_n.logo && offre.e_s_n.logo!='avatar.png'" class="table-img" src="{{urlimage + offre.e_s_n.logo}}" alt="" width="50px">
                                                    <img *ngIf="offre.e_s_n.logo && offre.e_s_n.logo=='avatar.png'" class="table-img" src="/assets/media/avatar.png" alt="" width="50px">
                                                    <img *ngIf="!offre.e_s_n.logo || offre.e_s_n.logo===undefined" class="table-img" src="/assets/media/avatar.png" alt="" width="50px"> -->
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-5">{{offre.name ? offre.name : '---'}}  </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="content-card">
                                                    <!--begin::Stats-->
                                                    <!-- <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee">
                                                             <span>Type :</span>
                                                            <span  *ngIf="offre?.e_s_n?.type=='2'"> Esn</span>
                                                            <span  *ngIf="offre?.e_s_n?.type=='3'"> Client Final</span>
                                                            <span  *ngIf="offre?.e_s_n?.type=='4'"> Cabinet de Recrutement</span>
                                                     <span *ngIf="!offre.e_s_n">---</span>

                                                  

                                                            
                                                        </div>
                                                    </div> -->

                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>ANS.EXP : </span><span *ngIf="offre.years_of_experience !=='0'|| offre.years_of_experience!==null"> {{offre.years_of_experience? offre.years_of_experience :'---'}} ans </span>
                                                            <span *ngIf="offre.years_of_experience ==='0'|| offre.years_of_experience===null">---</span>
                                                       
                                                        </div>
                                                    </div>
    
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>Salaire :</span> 
                                                            <span *ngIf="offre.salary !=='0'|| offre.salary!==null"> {{offre.salary + ' &euro;' ? offre.salary :'---' }}</span>
                                                            <span *ngIf="offre.salary ==='0'|| offre.salary===null">---</span>
                                                         </div>
                                                    </div>
    
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>Tjm :</span> 
                                                            <span *ngIf="offre.tjm !=='0'|| offre.tjm!==null">{{offre.tjm + ' &euro;' ? offre.tjm   : '---'}}</span> 
                                                            <span *ngIf="offre.tjm ==='0'|| offre.tjm===null">---</span>
                                                        
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                   
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                   
                                                  
                                                    <!--end::Stats-->
                                                </div>
                                            

                                                <!--end::Info-->
                                            </div>
                                           
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                               
                                    <div class="pagination" *ngIf="listcandidature && listcandidature.length">
                                        <app-pagination [data]="listcandidature" [lengthData]="totalItems" (setPages)="getItems($event)" [currentPageList]="currentPage" [endexPageList]="endIndex"> </app-pagination>
                                      </div>
                                     <div class="alert alert-warning text-center mt-5" role="alert"
                                          *ngIf="listcandidature && !listcandidature.length">
                                  <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                                  <span class="empty-list">
                                      La liste est vide
                                  </span>
                              </div>

                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                                <div class="content">
                                    <div class="pt-3">
                                        <!--begin::Table-->
                                        <div class="table-responsive" id="kt_customers_table">
                                            <table class="table align-middle gy-5 style-table" >
                                                <thead>
                                                    <tr class="text-start text-gray-400 fw-bold text-uppercase gs-0">
                                                        <th class="min-w-125px"><span>ID </span></th>
                                                    <th class="min-w-125px"> <span>logo entreprise</span></th>
                                                        <th class="min-w-125px th-fixed"> <span>Nom entreprise</span></th>
                                                        <th class="min-w-125px "><span>Type</span></th>
                                                        <th class="min-w-125px th-fixed2"><span>POSTE</span></th>
                                                        <th class="min-w-175px"><span>Nom Consultant</span></th>
                                                        <th class="min-w-175px"><span>Date de publication</span></th>
                                                        <th class="min-w-175px"><span>Années d’expérience</span></th>
                                                        <th class="min-w-125px"><span>TYPE DE CONTRAT</span></th>
                                                        <th class="min-w-125px"><span>SALAIRE</span></th>
                                                        <th class="min-w-125px"><span>TJM</span></th>
                                                        <th class="min-w-125px"><span>TYPE DE POSTE</span></th> 
                                                        <th class="min-w-125px"><span>Compétences</span></th>
                                                        <!-- <th class="min-w-125px">Disponibilité <i (click)="sortData('availability')" class="fa-solid fa-sort"></i></th> -->
                                                        <th class="min-w-125px"><span>Pays</span></th>
                                                        <th class="min-w-125px"><span>VILLE</span> </th>
                                                        <th class="min-w-125px"><span>STATUT</span>
                                                        </th>
                                                        <th class="min-w-90px"><span>Actions</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody class="fw-semibold text-gray-600">
                                                    <tr *ngFor="let offre of listcandidature">
                                                        <td>
                                                            <a  routerLink="/esn-offres-emploi/details-offer-candidature/{{offre.company_apply_id}}" class="first-td">{{offre.ID_jobOffer ? offre.ID_jobOffer
                                                                :'---'}}</a>
                                                        </td>
                                                        <td>
                                                            <!-- <img class="circular-image" *ngIf="offre.e_s_n?.logo && offre.e_s_n.logo!='avatar.png'" src="{{urlimage + offre.e_s_n.logo}}" alt="" width="50px" height="50px">
                                                            <img  class="circular-image" *ngIf="offre.e_s_n.logo && offre.e_s_n.logo=='avatar.png'"  src="/assets/media/avatar.png" alt="" width="50px" height="50px">
                                                            <img class="circular-image" *ngIf="!offre.e_s_n.logo || offre.e_s_n.logo===undefined"  src="/assets/media/avatar.png" alt="" width="50px" height="50px"> -->
                                                            <img class="circular-image" *ngIf="offre.e_s_n.logo &&  offre.e_s_n.logo!=='undefined'" src="{{url+'/Company/file/gallery_company/'+ offre.e_s_n.logo}}" alt="logo" width="50px" height="50px">

                                                        </td>
                                                        <td class="td-fixed">
                                                            <span>{{offre?.e_s_n?.name ? offre?.e_s_n?.name :'---'}}</span>
                                                          </td>
                                                          <td >
                                                            <span class="badge java" *ngIf="offre?.e_s_n?.type=='2'"> ESN</span>
                                                            <span class="badge java" *ngIf="offre?.e_s_n?.type=='3'"> Client Final</span>
                                                            <span class="badge java" *ngIf="offre?.e_s_n?.type=='4'"> Cabinet de Recrutement</span>

                                                            <span *ngIf="!offre.e_s_n">---</span>
                                                        </td>
                                                        <td class="td-fixed2">
                                                          <span  routerLink="/esn-offres-emploi/details-offer-candidature/{{offre.company_apply_id}}" class="poste cursor-pointer">{{offre.name? offre.name:'---' }}</span>
                                                       
                                                       
                                                        </td>
                                                        <td><span class="cursor-pointer poste"  [routerLink]="['/candidats/profilecandidatesn',offre?.User_id]"> {{offre.User_full_name ? offre.User_full_name :'---'}}</span></td>
                                                        <td>
                                                            <span>
                                                                {{ !offre.start_date ? '---' : offre.start_date.split(' ')[0].split('-').reverse().join('/') }}
                                                            </span>
                                                        </td>
                                                          <td>
                                                            <span>{{offre.years_of_experience ? offre.years_of_experience :'---'}} ans</span>
                                                         </td>
                                                         <td>
                                                            <ng-container *ngFor="let contract of offre.contract_type">
                                                                <span *ngIf="contract==1">Alternance</span>&nbsp;&nbsp;
                                                                <span *ngIf="contract==2">Autres type de contrat</span>&nbsp;&nbsp;
                                                                <span *ngIf="contract==3">CDD</span>&nbsp;&nbsp;
                                                                <span *ngIf="contract==4">CDI</span>
                                                                <span *ngIf="contract==5">Freelance</span>
                                                                <span *ngIf="contract==6">Portage salarial</span>
                                                                <span *ngIf="contract==7">Stage</span>
                                             
                                                            </ng-container>
                                                            <span class="color-blue"*ngIf="offre.contract_type.length==0">---</span>

                                                        </td>
                                                        <td>
                                                            <span *ngIf="offre.salary">{{ offre.salary ? offre.salary + '&euro;' : '---'}} </span>
                                                           
                                                           
                                                        </td>
                                                        <td>
                                                          <span *ngIf="offre.tjm">{{ offre.tjm ? offre.tjm + '&euro;' :'---'}} &euro;</span>
                                                       
                                                        </td>
                                                        <td>
                                                            
                                                            <span *ngIf="offre.post_type==1"
                                                        class="badge remote">A distance</span>
                                                    <span *ngIf="offre.post_type==2" class="badge onsite">Hybride</span>
                                                    <span *ngIf="offre.post_type==3"
                                                        class="badge hybrid">Sur site</span>
                                                        <span *ngIf="!offre.post_type">---</span>
                                                    
                                                        </td>
                                                        <td>
                                                            <ng-container *ngIf="offre.skills_job">
                                                                <div class="skills">
                                                                    <span [ngClass]="backGroundColors[i]" class="badge java"
                                                                        *ngFor="let skill of offre.skills_job.slice(0,3) let i = index">
                                                                        {{ skill.sub_category.name_FR }}
                                                                    </span>
                                                                </div>
                                                            </ng-container>
                                                            <span    *ngIf="offre.skills_job?.length && offre.skills_job?.length>2"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M7.34144 4.86849H4.51344V7.76649H3.02944V4.86849H0.201438V3.52449H3.02944V0.626487H4.51344V3.52449H7.34144V4.86849Z" fill="#ACA7A7"/>
                                                                </svg>
                                                                </span>
                                                            <span *ngIf="offre.skills_job.length==0">---</span>
                                                        </td>
                                                     
                                                        <!-- <td> 
                                                            <span  *ngIf="offre.availability==1" class="badge remote">ASAP</span>
                                                            <span *ngIf="offre.availability==2" class="badge remote">Sous 1 mois</span>
                                                            <span  *ngIf="offre.availability==3" class="badge remote">2 mois</span>
                                                            <span  *ngIf="offre.availability==4" class="badge remote">3 mois</span>
                                                            <span  *ngIf="offre.availability==5" class="badge remote">4 mois</span>
                                                        </td> -->
                                                        <td>
                                                            <span>{{offre.country ? offre.country :'---'}} </span>
                                                          </td>
                                                        <td>
                                                            <span>{{offre.city ? offre.city :'---'}} </span>
                                                          </td>
                                                         
                                                         
                                                   
                                                        
                                                          <td>
                                                            <span class="badge actif" *ngIf="offre.state==0"> <i class="fa-solid fa-circle"></i> Actif</span>
                                                            <span class="badge desactif" *ngIf="offre.state==1"> <i class="fa-solid fa-circle"></i> Non actif</span>
                                                        </td>
                                                            <td class="actions">
                                                                <div class="tools">
                                                                    <div class="dropdown">
                                                                        <button
                                                                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                            type="button" id="dropdownMenuButton"
                                                                            data-bs-toggle="dropdown" aria-haspopup="true"
                                                                            aria-expanded="false">
                                                                            <svg width="19" height="5" viewBox="0 0 19 5"
                                                                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                                    transform="matrix(1 0 0 -1 0 4.89478)"
                                                                                    fill="#265D91" />
                                                                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                                    transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                                    fill="#265D91" />
                                                                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                                    transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                                    fill="#265D91" />
                                                                            </svg>
                                                                        </button>
                                                                        <div class="dropdown-menu"
                                                                            aria-labelledby="dropdownMenuButton">
                                                    
                                                                            <a class="dropdown-item"  routerLink="/esn-offres-emploi/details-offer-candidature/{{offre.company_apply_id}}">Voir Détail </a>
                                                                            <a class="dropdown-item" (click)="retirercandidature(offre)"
                                                                          >Retirer La candidature
                                                                           </a>
                                                                           <a   [routerLink]="['/dossier-candidature',offre.id,offre.User_id,3,offre.company_apply_id]"
                                                                           class="dropdown-item cursor-pointer" >voir dossier de candidature </a>
                                                                           
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!--end::Menu-->
                                                            </td>
                                                    </tr>
                                            
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                        <div class="pagination" *ngIf="listcandidature && listcandidature.length">
                                            <app-pagination [data]="listcandidature" [lengthData]="totalItems" (setPages)="getItems($event)" [currentPageList]="currentPage" [endexPageList]="endIndex"> </app-pagination>
                                          </div>
                                         <div class="alert alert-warning text-center mt-5" role="alert"
                                              *ngIf="listcandidature && !listcandidature.length">
                                      <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                                      <span class="empty-list">
                                          La liste est vide
                                      </span>
                                  </div>
                                    </div>
                                </div>
                            </div>
                            <!--end::Tab pane-->
                        </div>

                        <div class="tab-content for-mobile">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                                <!--begin::Row-->
                                <div class="row g-6 g-xl-9 justify-content-center">
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4" *ngFor="let offre of listcandidature">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">

                                                <div class="dropdown">
                                                    <button
                                                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                        type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                fill="#265D91" />
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                fill="#265D91" />
                                                        </svg>
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <!-- <a class="dropdown-item dropdown" >Voir offre</a> -->
                                                        <a class="dropdown-item dropdown"  routerLink="/esn-offres-emploi/details-offer-candidature/{{offre.company_apply_id}}">Voir Détail</a>
                                                        <!-- <a class="dropdown-item dropdown" >Modifier</a> -->
    
                                                        <a class="dropdown-item dropdown"  (click)="retirercandidature(offre)">Retirer La candidature</a>
                                                      
                                                  

                                                    </div>
                                                </div>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <!-- <img src="assets/media//avatars/300-2.jpg" alt="image" /> -->
                                                    <img *ngIf="offre.e_s_n.logo && offre.e_s_n.logo!='avatar.png'" class="table-img" src="{{urlimage + offre.e_s_n.logo}}" alt="" width="50px">
                                                    <img *ngIf="offre.e_s_n.logo && offre.e_s_n.logo=='avatar.png'" class="table-img" src="/assets/media/avatar.png" alt="" width="50px">
                                                    <img *ngIf="!offre.e_s_n.logo || offre.e_s_n.logo===undefined" class="table-img" src="/assets/media/avatar.png" alt="" width="50px">
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-5">{{offre.name ? offre.name : '---'}}  </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="content-card">
                                                    <!--begin::Stats-->
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee">
                                                             <span>Type :</span>
                                                            <span  *ngIf="offre?.e_s_n?.type=='2'"> Esn</span>
                                                            <span  *ngIf="offre?.e_s_n?.type=='3'"> Client Final</span>
                                                            <span  *ngIf="offre?.e_s_n?.type=='4'"> Cabinet de Recrutement</span>
                                                     <span *ngIf="!offre.e_s_n">---</span>

                                                     <!-- <span *ngIf="appel.client_final.type=='2'"> ESN</span> -->

                                                            
                                                        </div>
                                                    </div>

                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>ANS.EXP :</span> {{offre.years_of_experience? offre.years_of_experience :'---'}} </div>
                                                    </div>
    
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>Salaire :</span> {{offre.salary + ' &euro;' ? offre.salary :'---' }} </div>
                                                    </div>
    
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>Tjm :</span> {{offre.tjm + ' &euro;' ? offre.tjm   : '---'}} </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                    <!-- <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>VILLE :</span> {{offre.city}}</div>
                                                    </div> -->
                                                    <!-- <div class="types py-3 px-4 mx-2">
                                                        <ng-container *ngFor="let contract of offre.contract_type">
                                                                <div class="badge-annee"*ngIf="contract==1">CDI</div>&nbsp;
                                                                <div class="badge-annee" *ngIf="contract==2">CDD</div>&nbsp;
                                                                <div class="badge-annee" *ngIf="contract==3">SIVP</div>&nbsp;
                                                                <div class="badge-annee" *ngIf="contract==4">Freelance</div>
                                                                </ng-container>
                                                    </div> -->
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                   
                                                  
                                                    <!--end::Stats-->
                                                </div>
                                            

                                                <!--end::Info-->
                                            </div>
                                            <!-- <div class="foot p-5">
                                                <div class="poste">

                                                    <span  *ngIf="offre.post_type==1" class="badge remote">Hybrid</span>
                                                    <span *ngIf="offre.post_type==2" class="badge remote">À distance</span>
                                                    <span  *ngIf="offre.post_type==3" class="badge remote">Télétravail</span>
                                                </div>
                                                <div class="plus">
                                                    <a  routerLink="/esn-offres-emploi/details-offer-candidature/{{offre.id}}">Voir plus</a>
                                                </div>
                                            </div> -->
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                               
                                    <div class="pagination" *ngIf="listcandidature && listcandidature.length">
                                        <app-pagination [data]="listcandidature" [lengthData]="totalItems" (setPages)="getItems($event)" [currentPageList]="currentPage" [endexPageList]="endIndex"> </app-pagination>
                                      </div>
                                     <div class="alert alert-warning text-center mt-5" role="alert"
                                          *ngIf="listcandidature && !listcandidature.length">
                                  <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                                  <span class="empty-list">
                                      La liste est vide
                                  </span>
                              </div>

                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                          
                            <!--end::Tab pane-->
                        </div>
                            <!--end::Table-->
                        </div>
                        <!--end::Card body-->
                       
                        
      
                    </div>
                    <!--end::Card-->
                  
           
                    <!--begin::Modals-->
                    <!--begin::Modal - Customers - Add-->

                    <!--end::Modal - Customers - Add-->
                    <!--begin::Modal - Adjust Balance-->

                    <!--end::Modal - New Card-->
                    <!--end::Modals-->
                </div>
                <!--end::Content container-->
            </div>
            <!--end::Content-->
        </div>
        <!--end::Content wrapper-->
        <!--begin::Footer-->

        <!--end::Footer-->
    <!--end:::Main-->
    </div>
    <script src="./assets/js/custom/apps/projects/settings/settings.js"></script>
    <script src="./assets/js/widgets.bundle.js"></script>
    <script src="./assets/js/custom/widgets.js"></script>
    <script src="./assets/js/custom/apps/chat/chat.js"></script>
    <script src="./assets/js/custom/apps/ecommerce/customers/listing/listing.js"></script>
		<script src="./assets/js/custom/apps/ecommerce/customers/listing/add.js"></script>
		<script src="./assets/js/custom/apps/ecommerce/customers/listing/export.js"></script>
        <div class="modal fade" id="propose" tabindex="-1" aria-hidden="true">
			<!--begin::Modal dialog-->
			<div class="modal-dialog mw-700px modal-dialog-centered">
				<!--begin::Modal content-->
				<div class="modal-content">
					<!--begin::Modal header-->
					<div class="modal-header pb-0 border-0 d-flex justify-content-end">
						<!--begin::Close-->
						<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
							<i class="ki-duotone ki-cross fs-1">
								<span class="path1"></span>
								<span class="path2"></span>
							</i>
						</div>
						<!--end::Close-->
					</div>
					<!--end::Modal header-->
					<!--begin::Modal body-->
					<div class="modal-body scroll-y mx-5 mx-xl-10 pt-0 pb-15">
						<!--begin::Heading-->
						<div class="text-center mb-13">
							<!--begin::Title-->
							<h1 class="d-flex justify-content-center align-items-center mb-3">Proposer un candidat
							<span class="badge badge-circle badge-secondary ms-3">81</span></h1>
							<!--end::Title-->
							
						</div>
						<!--end::Heading-->
						<!--begin::Users-->
						<div class="mh-475px scroll-y me-n7 pe-7">
							<!--begin::User-->
							<div class="border border-hover-primary p-7 rounded mb-7">
								<!--begin::Info-->
								<div class="d-flex flex-stack pb-3">
									<!--begin::Info-->
									<div class="d-flex">
										<!--begin::Avatar-->
										<div class="symbol symbol-circle symbol-45px">
											<img src="assets/media/avatars/300-20.jpg" alt="" />
										</div>
										<!--end::Avatar-->
										<!--begin::Details-->
										<div class="ms-5">
											<!--begin::Name-->
											<div class="d-flex align-items-center">
												<a href="../../demo1/dist/pages/user-profile/overview.html" class="text-dark fw-bold text-hover-primary fs-5 me-4">Amine chouri</a>
												<!--begin::Label-->
												<span class="badge badge-light-success d-flex align-items-center fs-8 fw-semibold">
												<i class="ki-duotone ki-star fs-8 text-success me-1"></i>Author</span>
												<!--end::Label-->
											</div>
											<!--end::Name-->
											<!--begin::Desc-->
											<span class="text-muted fw-semibold mb-3">Art Director</span>
											<!--end::Desc-->
										</div>
										<!--end::Details-->
									</div>
									<!--end::Info-->
									<!--begin::Stats-->
									<div clas="d-flex">
										<!--begin::Price-->
										<div class="text-end pb-3">
											<span class="text-dark fw-bold fs-5">$75.60</span>
											<span class="text-muted fs-7">/hr</span>
										</div>
										<!--end::Price-->
									</div>
									<!--end::Stats-->
								</div>
								<!--end::Info-->
								<!--begin::Wrapper-->
								<div class="p-0">
									<!--begin::Section-->
									<div class="d-flex flex-column">
										<!--begin::Text-->
										<p class="text-gray-700 fw-semibold fs-6 mb-4">First, a disclaimer - the entire process writing a blog post often takes more.</p>
										<!--end::Text-->
										<!--begin::Tags-->
										<div class="d-flex text-gray-700 fw-semibold fs-7">
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">Art Director</span>
											<!--end::Tag-->
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">UX</span>
											<!--end::Tag-->
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">Laravel</span>
											<!--end::Tag-->
										</div>
										<!--end::Tags-->
									</div>
									<!--end::Section-->
									<!--begin::Footer-->
									<div class="d-flex flex-column">
										<!--begin::Separator-->
										<div class="separator separator-dashed border-muted my-5"></div>
										<!--end::Separator-->
										<!--begin::Action-->
										<div class="d-flex flex-stack">
											<!--begin::Progress-->
											<div class="d-flex flex-column mw-200px">
												<div class="d-flex align-items-center mb-2">
													<span class="text-gray-700 fs-6 fw-semibold me-2">90%</span>
													<span class="text-muted fs-8">Job Success</span>
												</div>
												<div class="progress h-6px w-200px">
													<div class="progress-bar bg-primary" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
												</div>
											</div>
											<!--end::Progress-->
											<!--begin::Button-->
											<a href="#" class="btn btn-sm btn-primary">Select</a>
											<!--end::Button-->
										</div>
										<!--end::Action-->
									</div>
									<!--end::Footer-->
								</div>
								<!--end::Wrapper-->
							</div>
							<!--end::User-->
							<!--begin::User-->
							<div class="border border-hover-primary p-7 rounded mb-7">
								<!--begin::Info-->
								<div class="d-flex flex-stack pb-3">
									<!--begin::Info-->
									<div class="d-flex">
										<!--begin::Avatar-->
										<div class="symbol symbol-circle symbol-45px">
											<img src="assets/media/avatars/300-11.jpg" alt="" />
										</div>
										<!--end::Avatar-->
										<!--begin::Details-->
										<div class="ms-5">
											<!--begin::Name-->
											<div class="d-flex align-items-center">
												<a href="../../demo1/dist/pages/user-profile/overview.html" class="text-dark fw-bold text-hover-primary fs-5 me-4">Sean Bean</a>
												<!--begin::Label-->
												<span class="badge badge-light-success d-flex align-items-center fs-8 fw-semibold">
												<i class="ki-duotone ki-star fs-8 text-success me-1"></i>Author</span>
												<!--end::Label-->
											</div>
											<!--end::Name-->
											<!--begin::Desc-->
											<span class="text-muted fw-semibold mb-3">Project Manager</span>
											<!--end::Desc-->
										</div>
										<!--end::Details-->
									</div>
									<!--end::Info-->
									<!--begin::Stats-->
									<div clas="d-flex">
										<!--begin::Price-->
										<div class="text-end pb-3">
											<span class="text-dark fw-bold fs-5">$65.45</span>
											<span class="text-muted fs-7">/hr</span>
										</div>
										<!--end::Price-->
									</div>
									<!--end::Stats-->
								</div>
								<!--end::Info-->
								<!--begin::Wrapper-->
								<div class="p-0">
									<!--begin::Section-->
									<div class="d-flex flex-column">
										<!--begin::Text-->
										<p class="text-gray-700 fw-semibold fs-6 mb-4">Outlines keep you honest. They stop you from indulging.</p>
										<!--end::Text-->
										<!--begin::Tags-->
										<div class="d-flex text-gray-700 fw-semibold fs-7">
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">HTML</span>
											<!--end::Tag-->
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">Javascript</span>
											<!--end::Tag-->
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">Python</span>
											<!--end::Tag-->
										</div>
										<!--end::Tags-->
									</div>
									<!--end::Section-->
									<!--begin::Footer-->
									<div class="d-flex flex-column">
										<!--begin::Separator-->
										<div class="separator separator-dashed border-muted my-5"></div>
										<!--end::Separator-->
										<!--begin::Action-->
										<div class="d-flex flex-stack">
											<!--begin::Progress-->
											<div class="d-flex flex-column mw-200px">
												<div class="d-flex align-items-center mb-2">
													<span class="text-gray-700 fs-6 fw-semibold me-2">58%</span>
													<span class="text-muted fs-8">Job Success</span>
												</div>
												<div class="progress h-6px w-200px">
													<div class="progress-bar bg-success" role="progressbar" style="width: 58%" aria-valuenow="58" aria-valuemin="0" aria-valuemax="100"></div>
												</div>
											</div>
											<!--end::Progress-->
											<!--begin::Button-->
											<a href="#" class="btn btn-sm btn-primary">Select</a>
											<!--end::Button-->
										</div>
										<!--end::Action-->
									</div>
									<!--end::Footer-->
								</div>
								<!--end::Wrapper-->
							</div>
							<!--end::User-->
							<!--begin::User-->
							<div class="border border-hover-primary p-7 rounded mb-7">
								<!--begin::Info-->
								<div class="d-flex flex-stack pb-3">
									<!--begin::Info-->
									<div class="d-flex">
										<!--begin::Avatar-->
										<div class="symbol symbol-circle symbol-45px">
											<img src="assets/media/avatars/300-2.jpg" alt="" />
										</div>
										<!--end::Avatar-->
										<!--begin::Details-->
										<div class="ms-5">
											<!--begin::Name-->
											<div class="d-flex align-items-center">
												<a href="../../demo1/dist/pages/user-profile/overview.html" class="text-dark fw-bold text-hover-primary fs-5 me-4">Lusy Kunic</a>
												<!--begin::Label-->
												<span class="m-0"></span>
												<!--end::Label-->
											</div>
											<!--end::Name-->
											<!--begin::Desc-->
											<span class="text-muted fw-semibold mb-3">DevOPs</span>
											<!--end::Desc-->
										</div>
										<!--end::Details-->
									</div>
									<!--end::Info-->
									<!--begin::Stats-->
									<div clas="d-flex">
										<!--begin::Price-->
										<div class="text-end pb-3">
											<span class="text-dark fw-bold fs-5">$60,45</span>
											<span class="text-muted fs-7">/hr</span>
										</div>
										<!--end::Price-->
									</div>
									<!--end::Stats-->
								</div>
								<!--end::Info-->
								<!--begin::Wrapper-->
								<div class="p-0">
									<!--begin::Section-->
									<div class="d-flex flex-column">
										<!--begin::Text-->
										<p class="text-gray-700 fw-semibold fs-6 mb-4">Long before you sit down to put digital pen to paper you need make sure you have to sit down and write.</p>
										<!--end::Text-->
										<!--begin::Tags-->
										<div class="d-flex text-gray-700 fw-semibold fs-7">
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">Figma</span>
											<!--end::Tag-->
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">SASS</span>
											<!--end::Tag-->
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">CSS</span>
											<!--end::Tag-->
										</div>
										<!--end::Tags-->
									</div>
									<!--end::Section-->
									<!--begin::Footer-->
									<div class="d-flex flex-column">
										<!--begin::Separator-->
										<div class="separator separator-dashed border-muted my-5"></div>
										<!--end::Separator-->
										<!--begin::Action-->
										<div class="d-flex flex-stack">
											<!--begin::Progress-->
											<div class="d-flex flex-column mw-200px">
												<div class="d-flex align-items-center mb-2">
													<span class="text-gray-700 fs-6 fw-semibold me-2">86%</span>
													<span class="text-muted fs-8">Job Success</span>
												</div>
												<div class="progress h-6px w-200px">
													<div class="progress-bar bg-warning" role="progressbar" style="width: 86%" aria-valuenow="86" aria-valuemin="0" aria-valuemax="100"></div>
												</div>
											</div>
											<!--end::Progress-->
											<!--begin::Button-->
											<a href="#" class="btn btn-sm btn-primary">Select</a>
											<!--end::Button-->
										</div>
										<!--end::Action-->
									</div>
									<!--end::Footer-->
								</div>
								<!--end::Wrapper-->
							</div>
							<!--end::User-->
							<!--begin::User-->
							<div class="border border-hover-primary p-7 rounded">
								<!--begin::Info-->
								<div class="d-flex flex-stack pb-3">
									<!--begin::Info-->
									<div class="d-flex">
										<!--begin::Avatar-->
										<div class="symbol symbol-circle symbol-45px">
											<img src="assets/media/avatars/300-5.jpg" alt="" />
										</div>
										<!--end::Avatar-->
										<!--begin::Details-->
										<div class="ms-5">
											<!--begin::Name-->
											<div class="d-flex align-items-center">
												<a href="../../demo1/dist/pages/user-profile/overview.html" class="text-dark fw-bold text-hover-primary fs-5 me-4">Mat Dillon</a>
												<!--begin::Label-->
												<span class="m-0"></span>
												<!--end::Label-->
											</div>
											<!--end::Name-->
											<!--begin::Desc-->
											<span class="text-muted fw-semibold mb-3">QA Managers</span>
											<!--end::Desc-->
										</div>
										<!--end::Details-->
									</div>
									<!--end::Info-->
									<!--begin::Stats-->
									<div clas="d-flex">
										<!--begin::Price-->
										<div class="text-end pb-3">
											<span class="text-dark fw-bold fs-5">$70,30</span>
											<span class="text-muted fs-7">/hr</span>
										</div>
										<!--end::Price-->
									</div>
									<!--end::Stats-->
								</div>
								<!--end::Info-->
								<!--begin::Wrapper-->
								<div class="p-0">
									<!--begin::Section-->
									<div class="d-flex flex-column">
										<!--begin::Text-->
										<p class="text-gray-700 fw-semibold fs-6 mb-4">First, a disclaimer - the entire process writing a blog post often takes more than couple of hours.</p>
										<!--end::Text-->
										<!--begin::Tags-->
										<div class="d-flex text-gray-700 fw-semibold fs-7">
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">Figma</span>
											<!--end::Tag-->
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">SASS</span>
											<!--end::Tag-->
											<!--begin::Tag-->
											<span class="border border-2 rounded me-3 p-1 px-2">CSS</span>
											<!--end::Tag-->
										</div>
										<!--end::Tags-->
									</div>
									<!--end::Section-->
									<!--begin::Footer-->
									<div class="d-flex flex-column">
										<!--begin::Separator-->
										<div class="separator separator-dashed border-muted my-5"></div>
										<!--end::Separator-->
										<!--begin::Action-->
										<div class="d-flex flex-stack">
											<!--begin::Progress-->
											<div class="d-flex flex-column mw-200px">
												<div class="d-flex align-items-center mb-2">
													<span class="text-gray-700 fs-6 fw-semibold me-2">70%</span>
													<span class="text-muted fs-8">Job Success</span>
												</div>
												<div class="progress h-6px w-200px">
													<div class="progress-bar bg-danger" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
												</div>
											</div>
											<!--end::Progress-->
											<!--begin::Button-->
											<a href="#" class="btn btn-sm btn-primary">Select</a>
											<!--end::Button-->
										</div>
										<!--end::Action-->
									</div>
									<!--end::Footer-->
								</div>
								<!--end::Wrapper-->
							</div>
							<!--end::User-->
						</div>
						<!--end::Users-->
					</div>
					<!--end::Modal Body-->
				</div>
				<!--end::Modal content-->
			</div>
			<!--end::Modal dialog-->
		</div>
        <div class="modal fade" id="modifier" tabindex="-1" aria-hidden="true">
			<!--begin::Modal dialog-->
			<div class="modal-dialog mw-700px modal-dialog-centered">
				<!--begin::Modal content-->
				<div class="modal-content">
					<!--begin::Modal header-->
					<div class="modal-header pb-0 border-0 d-flex justify-content-end">
						<!--begin::Close-->
						<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
							<i class="ki-duotone ki-cross fs-1">
								<span class="path1"></span>
								<span class="path2"></span>
							</i>
						</div>
						<!--end::Close-->
					</div>
					<!--end::Modal header-->
					<!--begin::Modal body-->
					<div class="modal-body scroll-y mx-5 mx-xl-10 pt-0 pb-15">
						<!--begin::Heading-->
						<div class="text-center mb-13">
							<!--begin::Title-->
							<h1 class="d-flex justify-content-center align-items-center mb-3">Modifier offre d'emploi
							<span class="badge badge-circle badge-secondary ms-3">81</span></h1>
							<!--end::Title-->
							
						</div>
						<!--end::Heading-->
						<!--begin::Users-->
						<div class="mh-475px scroll-y me-n7 pe-7">
							<!--begin::User-->
							<div class="row">
                                <div class="col-lg-6 tools mb-10">
                                    <input type="text" name="poste" id="poste" class="form-control mb-3" placeholder="Poste">
                                </div>
                                <div class="col-lg-6 mb-10">
                                    <select data-control="select2" data-placeholder="Select a format" data-hide-search="true" name="format" class="form-select mb-3">
                                        <option value="excell">Type de poste </option>
                                        <option value="pdf">hybride</option>
                                        <option value="cvs">à distance</option>
                                        <option value="zip">télétravail</option>
                                    </select>
                                </div>
                              
                                <div class="col-lg-6 tools mb-10">
									<select data-control="select2" data-placeholder="Select a format" data-hide-search="true" name="format" class="form-select mb-3">
                                        <option value="excell">Skills </option>
                                        <option value="pdf">Immédiate</option>
                                        <option value="zip">2 mois</option>
                                        <option value="zip">3 mois</option>
                                        <option value="zip">plus que 3 mois</option>
                                    </select>
                                </div>
                                <div class="col-lg-6 tools mb-10">
                                    <input type="text" name="pays" id="pays" class="form-control mb-3" placeholder="Pays">

                                </div>
                                <div class="col-lg-6 tools mb-10">
                                    <input type="text" name="Ville" id="Ville" class="form-control mb-3" placeholder="Ville">

                                </div>
                                <div class="col-lg-6 tools mb-10">
                                    <select data-control="select2" data-placeholder="Select a format" data-hide-search="true" name="format" class="form-select mb-3">
                                        <option value="excell">Disponibilité </option>
                                        <option value="pdf">Immédiate</option>

                                        <option value="zip">2 mois</option>
                                        <option value="zip">3 mois</option>
                                        <option value="zip">plus que 3 mois</option>
                                    </select>
                                </div>
                                <div class="col-lg-6 tools mb-10">
                                    <select data-control="select2" data-placeholder="Select a format" data-hide-search="true" name="format" class="form-select mb-3">
                                        <option value="excell">Type de contrat </option>
                                        <option value="pdf">CDI</option>
                                        <option value="cvs">CDD</option>
                                        <option value="zip">SIVP</option>
                                        <option value="zip">Freelance</option>
                                    </select>
                                </div>
                                <div class="col-lg-6 tools mb-10">
                                    <input type="number" name="annee" id="annee" placeholder="Années d'experience" class="form-control mb-3">
                                </div>
                                <div class="col-lg-6 tools mb-10">
                                    <input type="text" name="TJM" id="TJM" class="form-control mb-3" placeholder="TJM">

                                </div>
                                <div class="col-lg-6 tools mb-10">
                                    <input type="text" name="Salaire" id="Salaire" class="form-control mb-3" placeholder="Salaire">

                                </div>
                            </div>
                            <div class="row">
                                <div class="desc tools mb-10">
                                    <textarea name="desc" id="desc" placeholder="Description" style="height:150px" class="form-control"></textarea>
                                </div>
                            </div>
							<!--end::User-->
						</div>

						<div class="card-footer text-center">
							<div class="actions">
								<a  class="annuler" data-bs-dismiss="modal" aria-label="Close">Annuler</a>
								<a href="#" class="confirmer">Confirmer</a>
							</div>
						</div>
						<!--end::Users-->
					</div>
					
					<!--end::Modal Body-->
				</div>
				<!--end::Modal content-->
			</div>
			<!--end::Modal dialog-->
		</div>






        <div class="modal fade" id="send" tabindex="-1" aria-hidden="true">
            <!--begin::Modal dialog-->
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <!--begin::Modal content-->
                <div class="modal-content">
                    <!--begin::Modal header-->
                    <div class="modal-header pb-0 border-0 justify-content-end">
                        <!--begin::Close-->
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" aria-label="Close" >
                            <i class="ki-duotone ki-cross fs-1">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--begin::Modal header-->
                    <!--begin::Modal body-->
                    <div class="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                        <!--begin::Heading-->
                        <div class="text-center mb-13">
                            <!--begin::Title-->
                            <h1 class="mb-3">Postuler pour cette offre d'emploi</h1>
                            <!--end::Title-->
                            <!--begin::Description-->
                            <!-- <form  data-kt-search-element="form" class="w-100 position-relative mb-5" autocomplete="off">
                               
                                <input type="hidden" />
                            
                                <i class="ki-duotone ki-magnifier fs-2 fs-lg-1 text-gray-500 position-absolute left-0 top-50 ms-5 translate-middle-y">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                            
                                <input  type="text" class="form-control form-control-lg form-control-solid px-15" name="search" placeholder="Rechercher" data-kt-search-element="input" />
                           
                                
                             
                                <span class="position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-5" data-kt-search-element="spinner">
                                    <span class="spinner-border h-15px w-15px align-middle text-muted"></span>
                                </span>
                             
                                <span class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 me-5 d-none" data-kt-search-element="clear">
                                    <i class="ki-duotone ki-cross fs-2 fs-lg-1 me-0">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>
                                </span>
                             
                            </form> -->
                         
                        </div>
                        <!--end::Heading-->
                        <!--begin::Users-->
                        <div class="mb-15">
                            <!--begin::List-->
                            <div class="mh-375px scroll-y me-n7 pe-7" >
                                <!--begin::User-->
            
                                <div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed" *ngFor="let consultant of listconsultant">
                                    <!--begin::Details-->
                                    <div class="d-flex align-items-center">
                                        <div class="form-check">
                                            <input class="form-check-input" [value]="consultant.id" type="checkbox" (change)="getconsultantid($event, consultant.id)" [checked]="consultant.id === selectedUserId" />
                                            <!-- <input class="form-check-input" [value]="consultant.id" type="checkbox" (change)="getconsultantid($event)"  /> -->
                                           
                                        </div>
                                        <!--begin::Avatar-->
                                        <div class="symbol symbol-35px symbol-circle">
                                            <img class="circular-image" *ngIf="consultant.image_url&& consultant.image_url!='avatar.png'" class="table-img" src="{{urlimage + consultant.image_url}}" alt="Pic" width="50px" height="50px">
                                            <img class="circular-image" *ngIf="consultant.image_url && consultant.image_url=='avatar.png'" class="table-img" src="/assets/media/avatar.png" alt="Pic" width="50px" height="50px" >
                                            <img class="circular-image" *ngIf="!consultant.image_url || consultant.image_url===undefined" class="table-img" src="/assets/media/avatar.png" alt="Pic" width="50px" height="50px">
                                            <!-- <img alt="Pic" src="assets/media/avatars/300-12.jpg" /> -->
                                            <!-- {{ consultant.id }} -->
                                        </div>
                                        <!--end::Avatar-->
                                        <!--begin::Details-->
                                        <div class="ms-6" >
                                            <!--begin::Name-->
                                            <a href="#" class="d-flex align-items-center fs-5 fw-bold text-dark text-hover-primary">{{consultant.first_name}}   {{consultant.last_name}}
                                            <!-- <span class="badge badge-light fs-8 fw-semibold ms-2">Customer Relationship</span> -->
                                        </a>
                                            <!--end::Name-->
                                            <!--begin::Email-->
                                            <!-- <div class="fw-semibold text-muted">{{consultant.personal_email ? consultant.personal_email :'---'}}</div> -->
                                            <!--end::Email-->
                                        </div>
                                        <!--end::Details-->
                                    </div>
                                    <!--end::Details-->
                                    <!--begin::Stats-->
                                
                                    <!--end::Stats-->
                                </div>
                                <!--end::User-->
                                <!--begin::User-->
        
                                <!--end::User-->
                            </div>
                            <!--end::List-->
                        </div>
                        <!--end::Users-->
                        <!--begin::Notice-->
                    
                        <!--end::Notice-->
                    </div>
                    <div class="modal-footer">
                        <a href="" class="annuler" data-bs-dismiss="modal" aria-label="Close" style="cursor: pointer;">Annuler</a>
                        <a  class="confirmer" data-bs-dismiss="modal" style="cursor: pointer;" (click)="postuleroffre()">Postuler <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.3014 6.93489L1.8289 0.125525C1.60951 0.0223123 1.36294 -0.0185918 1.11926 0.00780132C0.875591 0.0341944 0.645346 0.126744 0.456611 0.274162C0.267876 0.42158 0.128808 0.617495 0.0563695 0.838012C-0.0160691 1.05853 -0.0187478 1.29412 0.04866 1.51604L1.89651 7.60228H8.49911C8.61083 7.60228 8.71798 7.64404 8.79698 7.71838C8.87598 7.79272 8.92036 7.89355 8.92036 7.99868C8.92036 8.10382 8.87598 8.20464 8.79698 8.27899C8.71798 8.35333 8.61083 8.39509 8.49911 8.39509H1.89651L0.04866 14.4813C-0.00455989 14.6581 -0.0136708 14.8441 0.0220375 15.0248C0.0577458 15.2055 0.137309 15.3759 0.254525 15.5229C0.371741 15.6699 0.523444 15.7894 0.69781 15.8722C0.872177 15.9549 1.0645 15.9987 1.25978 16C1.45757 15.9996 1.65252 15.9557 1.82911 15.8718L16.3014 9.06248C16.5114 8.96368 16.6879 8.81182 16.8113 8.62394C16.9347 8.43605 17 8.21955 17 7.99868C17 7.77782 16.9347 7.56132 16.8113 7.37343C16.6879 7.18554 16.5114 7.03369 16.3014 6.93489Z" fill="white"/>
                            </svg>
                            </a>
        
                    </div>
                    <!--end::Modal body-->
                </div>
                <!--end::Modal content-->
            </div>
            <!--end::Modal dialog-->
        </div>